var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 11,
    r: 5.6,
    fill: "white",
    stroke: "#8076FA",
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.967 10.9504L18.9505 7.97521L20.934 10.9504L18.9505 13.9256L16.967 10.9504Z",
    fill: "white",
    stroke: "#8076FA",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3489 20H6.74418C5.78243 20 5 20.7824 5 21.7442V28.2558C5 29.2176 5.78243 30 6.74418 30H15.3489C16.3106 30 17.093 29.2176 17.093 28.2558V21.7442C17.093 20.7824 16.3106 20 15.3489 20ZM16.3954 26.0465H13.8372C13.2602 26.0465 12.7907 25.5771 12.7907 25C12.7907 24.4229 13.2602 23.9535 13.8372 23.9535H16.3954V26.0465ZM16.3954 23.2558H13.8372C12.8755 23.2558 12.093 24.0382 12.093 25C12.093 25.9618 12.8755 26.7442 13.8372 26.7442H16.3954V28.2558C16.3954 28.8329 15.9259 29.3023 15.3489 29.3023H6.74418C6.16714 29.3023 5.69766 28.8329 5.69766 28.2558V21.7442C5.69766 21.1671 6.16712 20.6977 6.74418 20.6977H15.3489C15.9259 20.6977 16.3954 21.1671 16.3954 21.7442V23.2558Z",
    fill: "#8076FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12C11.5 12 9 13 9 14.5C9 16 9.00008 18 9.00008 18",
    stroke: "#8076FA",
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17L9 18L10.5 16.5",
    stroke: "#8076FA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.967fdd7a1481d876c8088b581eb64ac5.svg";
export { ForwardRef as ReactComponent };